import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from '@qga/roo-ui/components';
import PropertyMapStatic from 'components/PropertyPage/PropertyMapStatic';
import Renovations from 'components/PropertyPage/Renovations';
import { useBreakpoints } from 'hooks/useBreakpoints';

const PropertySummaryMap = ({ property }) => {
  const { isLessThanBreakpoint } = useBreakpoints();
  const isMobile = isLessThanBreakpoint(0);

  return (
    <Box px={[3, 3, 0]} borderTop={isMobile ? 1 : 0} borderColor={'greys.alto'}>
      <Flex flex="1 1 auto" flexDirection={['column', 'column', 'row']} mb={[0, 4, 6]}>
        <Flex flexDirection="column" minWidth={['100%', '100%', '400px']} pb={[4, 0, 0]}>
          <PropertyMapStatic
            locationName={property.name}
            latitude={property.latitude}
            longitude={property.longitude}
            address={property.address}
            width={[640, 640, 400]}
            height={[400, 640, 220]}
          />
        </Flex>
        {property.renovations && property.renovations !== 'undefined' && isMobile && (
          <Box>
            <Renovations renovations={property.renovations} />
          </Box>
        )}
      </Flex>
    </Box>
  );
};

PropertySummaryMap.propTypes = {
  property: PropTypes.object.isRequired,
};

export default PropertySummaryMap;
